import { IconContainer } from '@/components/IconContainer'
import { LinkIcon } from '@/icons'
import type { LinkTypeParam } from '@/types'

import s from './NoResults.module.css'

type Props = {
  query: string | null
  type?: LinkTypeParam
}

const titleText = {
  personal: 'No personal links found.',
  team: 'No team links found.',
  organization: 'No organization links found.',
  shared: 'No shared links yet.',
}

export const NoResults = ({ query, type }: Props) => {
  return (
    <div className={s.container}>
      <IconContainer>{LinkIcon}</IconContainer>
      <div className={s.text}>
        <div className={s.title}>
          {!!type ? titleText[type] : 'No results found.'}
        </div>
        {query && (
          <p className={s.description}>
            Check for a typo or try a different search term.
          </p>
        )}
        {!!type && <p className={s.description}>Try a different filter.</p>}
      </div>
    </div>
  )
}
